import isInSchedule from "./isInSchedule";

export default function isInScheduleField(data, today) {
  if (data.range_end && data.range_start) {
    const isInRange = isInSchedule(data.range_start, data.range_end, today);
    return isInRange;
  } else return true;
}
